import { VStack, Link as ChLink, Text } from "@chakra-ui/layout";
import React from "react";
import { Link } from "react-router-dom";
import { Card } from "../../components/Card/Card";
import { PageContent } from "../../components/PageContent/PageContent";
import { PageHeading } from "../../components/PageHeading/PageHeading";

export const Reports = () => {
  return (
    <>
      <PageHeading>
        <PageHeading.Title>Reports</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <Card w="100%">
          <VStack w="100%" alignItems="start" bgColor="white">
            <Card>
              <ChLink
                as={Link}
                to="/admin/reports/dmc-status"
                fontSize="lg"
                fontWeight="bold"
              >
                DMC Status
              </ChLink>
              <Text fontSize="sm">
                Download a Digital Membership Card Status across all Businesses
              </Text>
            </Card>

            <Card>
              <ChLink
                as={Link}
                to="/admin/reports/status"
                fontSize="lg"
                fontWeight="bold"
              >
                Status
              </ChLink>
              <Text fontSize="sm">
                A CherryPasses Downloaded by Members report across all
                Businesses
              </Text>
            </Card>

            <Card>
              <ChLink
                as={Link}
                to="/admin/reports/standard"
                fontSize="lg"
                fontWeight="bold"
              >
                Standard Reports
              </ChLink>
              <Text fontSize="sm">
                Download a standard periodic report across all Businesses
              </Text>
            </Card>

            <Card>
              <ChLink
                as={Link}
                to="/admin/reports/comparative"
                fontSize="lg"
                fontWeight="bold"
              >
                Comparative Reports
              </ChLink>
              <Text fontSize="sm">
                Download a comparative report across all Businesses
              </Text>
            </Card>

            <Card>
              <ChLink
                as={Link}
                to="/admin/reports/twilio-billing"
                fontSize="lg"
                fontWeight="bold"
              >
                Twilio Billing
              </ChLink>
              <Text fontSize="sm">Twilio SMS usage per sub-account</Text>
            </Card>
          </VStack>
        </Card>
      </PageContent>
    </>
  );
};
